<ng-container *ngIf="isInitialized">
  <div class="counter" [style.justify-content]="justify">
    <blinker-svg *ngIf="shouldBlink" width="6" height="6"></blinker-svg>
    {{ isUpcoming ? 'T-' : 'T+' }}
    <ng-container *ngIf="daysOnesTop || daysTensTop || daysHundredsTop">
      <launch-countdown-digit [top]="daysHundredsTop" *ngIf="daysHundredsTop"></launch-countdown-digit>
      <launch-countdown-digit [top]="daysTensTop" *ngIf="daysTensTop || daysHundredsTop"></launch-countdown-digit>
      <launch-countdown-digit [top]="daysOnesTop"></launch-countdown-digit>
      D&nbsp;
    </ng-container>
    <launch-countdown-digit [top]="hoursTensTop" numDigitValues="3"></launch-countdown-digit>
    <launch-countdown-digit [top]="hoursOnesTop"></launch-countdown-digit>
    :
    <launch-countdown-digit [top]="minutesTensTop" numDigitValues="6"></launch-countdown-digit>
    <launch-countdown-digit [top]="minutesOnesTop"></launch-countdown-digit>
    :
    <launch-countdown-digit [top]="secondsTensTop" numDigitValues="6"></launch-countdown-digit>
    <launch-countdown-digit [top]="secondsOnesTop"></launch-countdown-digit>
  </div>
</ng-container>